import http from "../../../services/http";
import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import {
  IAPI_COM007_Request,
  IAPI_COM007_Response,
  IAPI_STA007_Request,
  IAPI_STA007_Response,
  IAPI_STA014_Request,
  IAPI_STA014_Response,
  IAPI_STA017_Request,
  IAPI_STA017_Response,
  IAPI_FAC042_Request,
  IAPI_FAC042_Response,
} from "../../../type/apiType";

// 職員情報登録一覧参照API
const httpAPI_STA017 = async (
  param: IAPI_STA017_Request
): Promise<IAPI_STA017_Response> => {
  let res = await http.post(ApiUrl.API_STA017, {
    ...param,
  });

  return res.data;
};

// 新規登録職員一括更新API
const httpAPI_STA007 = async (
  param: IAPI_STA007_Request
): Promise<IAPI_STA007_Response> => {
  let res = await http.post(ApiUrl.API_STA007, {
    ...param,
  });

  return res.data;
};

// 職員情報削除API
const httpAPI_STA014 = async (
  param: IAPI_STA014_Request
): Promise<IAPI_STA014_Response> => {
  let res = await http.post(ApiUrl.API_STA014, {
    ...param,
  });
  return res.data;
};

// 申請等の関連帳票アップロード（汎用）API
const httpAPI_COM007 = async (
  param: IAPI_COM007_Request
): Promise<IAPI_COM007_Response> => {
  let res = await http.post(ApiUrl.API_COM007, {
    ...param,
  });

  return res.data;
};

// 職員登録完了更新
const httpAPI_FAC042 = async (
  param: IAPI_FAC042_Request
): Promise<IAPI_FAC042_Response> => {
  let res = await http.post(ApiUrl.API_FAC042, {
    ...param,
  });

  return res.data;
};

export {
  httpAPI_STA017,
  httpAPI_STA007,
  httpAPI_STA014,
  httpAPI_COM007,
  httpAPI_FAC042,
};
